import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { myJourneyShares, disablePostcardShare, enablePostcardShare, mediaUrl } from '../../lib/programsApi';

export const MySharedLinks = () => {
  const navigate = useNavigate();
  const [items, setItems] = useState(null);
  const load = () => myJourneyShares().then((d) => setItems(d.items)).catch(() => setItems([]));
  useEffect(() => { load(); }, []);
  if (!items || !items.length) return null;
  const fmt = (iso) => (iso ? new Date(iso).toLocaleDateString() : '—');
  const disable = async (t) => {
    if (!window.confirm('People with this link will no longer be able to view your Journey Postcard. Your journey completion and badge will remain unchanged.')) return;
    try { await disablePostcardShare(t); toast.success('Link disabled'); load(); } catch (e) { toast.error(e.message); }
  };
  const enable = async (t) => { try { await enablePostcardShare(t); toast.success('Link re-enabled (same link)'); load(); } catch (e) { toast.error(e.message); } };
  return (
    <div className="rounded-2xl p-4 bg-[#FFFCF3] border border-stone-200 mb-3" data-testid="my-shared-links">
      <p className="text-sm font-semibold text-stone-800 mb-2" style={{ fontFamily: "'DM Serif Display', serif" }}>My Shared Links</p>
      <div className="space-y-2">
        {items.map((s) => (
          <div key={s.token} className="flex gap-3 rounded-xl border border-stone-200 p-2" data-testid={`shared-link-${s.token}`}>
            <img src={mediaUrl(s.imageUrl)} alt="" className="w-14 h-[70px] object-cover rounded-lg" />
            <div className="flex-1 min-w-0 text-[11px] text-stone-600">
              <p className="text-sm font-semibold text-stone-800 truncate">{s.programTitle}</p>
              <p>Completed {fmt(s.completedAt)} · link created {fmt(s.createdAt)} · name {s.nameShown ? 'shown' : 'hidden'}</p>
              <p className={`font-semibold ${s.disabled ? 'text-stone-500' : 'text-emerald-700'}`} data-testid={`shared-link-status-${s.token}`}>{s.disabled ? 'Disabled' : 'Active'}</p>
              <div className="flex flex-wrap gap-2 mt-1">
                {!s.disabled && <button type="button" onClick={() => navigator.clipboard.writeText(s.url).then(() => toast.success('Link copied')).catch(() => toast(s.url))} className="font-semibold text-[#8a6a2a]" data-testid={`shared-link-copy-${s.token}`}>Copy Link</button>}
                {!s.disabled && <button type="button" onClick={() => navigate(`/journey/${s.token}`)} className="font-semibold text-[#1e3a5f]" data-testid={`shared-link-view-${s.token}`}>View</button>}
                {!s.disabled ? <button type="button" onClick={() => disable(s.token)} className="font-semibold text-rose-700" data-testid={`shared-link-disable-${s.token}`}>Disable Link</button>
                  : <button type="button" onClick={() => enable(s.token)} className="font-semibold text-[#1e3a5f]" data-testid={`shared-link-enable-${s.token}`}>Re-enable Link</button>}
              </div>
            </div>
          </div>
        ))}
      </div>
      <p className="text-[10.5px] text-stone-400 mt-2">Create a new link anytime from a completed journey's postcard.</p>
    </div>
  );
};
